import { z } from 'zod'

export const insuranceRentabilityTypes = z.enum([
  'ASIGNAR',
  'CONTRATAR_SIN_CUOTAS_ATRASADAS',
  'CONTRATAR_CON_CUOTAS_ATRASADAS',
  'EXTENSION'
])

export const insuranceRentabilityBasicSchema = z.object({
  month: z.string(),
  percentage: z.string(),
  name: z.string().nullable(),
  isActive: z.boolean(),
  type: insuranceRentabilityTypes
})

export const insuranceRentabilitySchema = insuranceRentabilityBasicSchema.merge(
  z.object({
    id: z.string()
  })
)

export type InsuranceRentability = z.infer<typeof insuranceRentabilitySchema>
